import { Prop, Watch } from "vue-property-decorator";
import { container } from "@/inversify.config";
import { DiTokens } from "../../services/diTokens";
import IAlertService from "../../services/alert/IAlertService";
import Vue from "vue";

/**
 *  Класс для компоненты поиска.
 */
export class SearchInputVue extends Vue {

  /** Значение контролла */
  @Prop() value!: string;

  /** Скрыть кнопку очистки */
  @Prop() clearHidden!: boolean;

  @Prop() placeholder!: string;

  /**
 * Сервис уведомлений
 * @returns {IAlertService}
 */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  /** Отслеживаем значение контролла из вне */
  @Watch('value', { immediate: true })
  queryChanged(val: string) {
    this.searchVal = val;
  }

  /** Отслеживаем значение контролла внутри */
  @Watch('searchVal', { immediate: true })
  searchValChanged(val: string) {
    this.$emit('queryChange', { query: val });
  }

  /** Значение контролла внутри */
  searchVal: string = "";

  /** Поиск элементов */
  searchCatalog() {
    this.$emit("searchCatalog", { query: this.searchVal, city: "" });
  }

  /** Очистить поиск */
  clearSearchCatalog() {
    this.$emit("searchCatalog", { query: null, city: null });
    this.searchVal = "";
  }
}
